import React, { Component } from 'react'
import { db } from '../../firebase/firebase'
import { dispatch } from '../../store'
import { connect } from 'react-redux'

const getUsers = async () => {
    const usersRef = await db.ref('/users')
    const usersSnap = await usersRef.once('value')
    const users = await usersSnap.val()
 
    const usersArr = Object.values(users)
    const usersOnlineRef = await db.ref('/userOnline')
    const usersOnlineSnap = await usersOnlineRef.once('value')
    const usersOnline = await usersOnlineSnap.val()
    const usersOnlineArr = await Object.values(usersOnline)

    const userOnlineIdsArr = []
    usersOnlineArr.map(userOnline=>userOnlineIdsArr.push(userOnline.userId))
    const offlineUsers = usersArr.filter(user=> {
        if(user.appUser)
            return user
        return null
    })
 
    dispatch({type: 'USERS_OFFLINE', payload: offlineUsers})
    
}

export class GetUnlockedUsersNotOnline extends Component {
    static propTypes = {

    }
    offlineUsers = []
    componentDidMount () {
        getUsers()

    }

    render() {
   
        return (
            <div>
                {this.props.usersOffline
                    ? this.props.usersOffline.map(userOffline=>userOffline.email +';')
                    : null
                }

            </div>
        )
    }
}

const mapStateToProps = state => ({
    usersOffline: state.userState.usersOffline
})



export default connect(mapStateToProps)(GetUnlockedUsersNotOnline)



// WEBPACK FOOTER //
// ./src/Components/Admin/GetUnlockedUsersNotOnline.js